/* RESPONSIBLE TEAM: team-ml */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import SdrRoutingOutcomeEditorConfig from 'embercom/objects/visual-builder/configuration/editor/sdr-routing-outcome';
import { CHANNEL_EMAIL } from 'embercom/lib/operator/custom-bots/constants';
import type IntlService from 'ember-intl/services/intl';
import type TriggerWorkflow from 'embercom/models/operator/visual-builder/step/trigger-workflow';

export default class SdrRoutingChannelCompatibility extends BaseValidator {
  @service declare intl: IntlService;

  validate(_value: unknown, _options: ValidationOptions, model: TriggerWorkflow) {
    let editorConfig = model.editorConfig;

    // Only validate when in SDR routing context
    if (!(editorConfig instanceof SdrRoutingOutcomeEditorConfig)) {
      return true;
    }

    let compatibleChannels = model.compatibleChannels;

    // SDR routing requires email compatibility since Fin SDR can run on email
    if (!compatibleChannels?.includes(CHANNEL_EMAIL)) {
      return this.intl.t(
        'operator.workflows.visual-builder.validations.sdr-routing-not-email-compatible',
      );
    }

    return true;
  }

  static getDependentsFor() {
    return ['model.compatibleChannels', 'model.editorConfig'];
  }
}
